// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import { 
    Box,
    Space 
} from '@mantine/core'

import { 
    useForm, 
    yupResolver 
} from '@mantine/form'


// Imports from vseth-canine-ui


// Imports from this projects
// Pages, Components, Features, Hooks
import {
    TagFormLayout
} from "../../layouts/forms/TagFormLayout"

import {
    TagValidationSchema
} from "./TagValidationSchema"

import { 
    createTagMessage
} from "../../features/tag/tagsSlice"

import { 
    useAppDispatch
} from '../../hooks/useAppDispatch'

import { 
    FormButtonBar 
} from '../../layouts/menuBars/general/FormButtonsBar'


/**
 * The Page component renders the admin page of the application.
 */
export const TagCreateForm = () => { 
    const dispatch = useAppDispatch()
    

    const form = useForm({
        initialValues: {
            tagName: '',
        },

        validate: yupResolver(TagValidationSchema)

    })


    return (
        <Box 
            mx="auto"
        >
            <form 
                onSubmit={form.onSubmit((values) => dispatch(createTagMessage(values)))}
            >
                <TagFormLayout
                    form={form}
                />
                <Space 
                    h="xl" 
                />
                <FormButtonBar/>
            </form>
        </Box>
    )
}